var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHierarchyBlue = function SvgIconHierarchyBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-hierarchy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "translate(0 9)",
    fill: "#4FA0EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "translate(9 9)",
    fill: "#4FA0EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 5,
    height: 3,
    rx: 0.5,
    transform: "translate(3.5)",
    fill: "#4FA0EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 3,
    height: 3,
    rx: 0.5,
    transform: "translate(4.5 9)",
    fill: "#4FA0EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M622.264 201.879v-2a1.5 1.5 0 0 0-1.5-1.5h-3v-2.5h-1v2.5h-3a1.5 1.5 0 0 0-1.5 1.5v2h1v-2a.5.5 0 0 1 .5-.5h3v2.5h1v-2.5h3a.5.5 0 0 1 .5.5v2Z",
    transform: "translate(-611.264 -192.879)",
    fill: "#BEE6FA"
  })));
};
export { SvgIconHierarchyBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1oaWVyYXJjaHkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMTIgMTIiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV81OSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjMiIHJ4PSIwLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgOSkiCiAgICAgICAgICBmaWxsPSIjNEZBMEVDIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzYwIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA2MCIgd2lkdGg9IjMiIGhlaWdodD0iMyIgcng9IjAuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOSA5KSIKICAgICAgICAgIGZpbGw9IiM0RkEwRUMiLz4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfNjEiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDYxIiB3aWR0aD0iNSIgaGVpZ2h0PSIzIiByeD0iMC41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjUpIgogICAgICAgICAgZmlsbD0iIzRGQTBFQyIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV82MiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNjIiIHdpZHRoPSIzIiBoZWlnaHQ9IjMiIHJ4PSIwLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuNSA5KSIKICAgICAgICAgIGZpbGw9IiM0RkEwRUMiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzMzNSIgZGF0YS1uYW1lPSJQYXRoIDMzNSIKICAgICAgICAgIGQ9Ik02MjIuMjY0LDIwMS44Nzl2LTJhMS41LDEuNSwwLDAsMC0xLjUtMS41aC0zdi0yLjVoLTF2Mi41aC0zYTEuNSwxLjUsMCwwLDAtMS41LDEuNXYyaDF2LTJhLjUuNSwwLDAsMSwuNS0uNWgzdjIuNWgxdi0yLjVoM2EuNS41LDAsMCwxLC41LjV2MloiCiAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjExLjI2NCAtMTkyLjg3OSkiIGZpbGw9IiNCRUU2RkEiLz4KPC9zdmc+";